export type IUserProfileType = "cliente" | "transportador" | "CIF" | "FOB";

export const userProfileTypeList = [
  {
    value: "customer",
    label: "Cliente",
  },
  {
    value: "carrier",
    label: "Transportador",
  },
  {
    value: "cif_driver",
    label: "Motorista CIF",
  },
  {
    value: "fob_driver",
    label: "Motorista FOB",
  },
];

export const getLabelProfileTypeList = (profileValue: string) => {
  return userProfileTypeList.find(
    (profileType) => profileType.value === profileValue
  )?.label;
};
